import Signing from '@app/store/documents/Signing';

export function isSignedParticipant(signings: Signing[], p: { id: string }) {
  return signings.some((signedParticipant) => signedParticipant.participantId === p.id);
}

/**
 * @deprecated TODO (@DevSDk): 후속에서 정리 하기
 */
export function isSignedParticipantDeprecated(signings: Signing[], p: { participantId: string }) {
  return signings
    .filter((signing) => !signing.expiredAt)
    .some((signedParticipant) => signedParticipant.participantId === p.participantId);
}
